import React, { Component } from 'react'

export default class FourthDiv extends Component {
  render() {
    return (
      <div className='fourth-div'>
        <h3>Community</h3>
        <a href='#'>Find Ableton User Groups<i class='bx bx-chevron-right'></i></a>
        <a href='#'>Find Certified Training<i class='bx bx-chevron-right'></i></a>
        <a href='#'>Become a Certified Trainer<i class='bx bx-chevron-right'></i></a>
      </div>
    )
  }
}
